import React, { useState, useEffect, useRef, useContext } from 'react';
import { Form, Input, message } from 'antd';

import { renderIntlLabel } from '@/utils';
import { parse2Number, parseFen2Currency, parseYuan2Fen } from '@/utils/number';
import { validateAmount, formatAmount } from '@/pages/bill/util/helper';
import IntlContext from '@/components/Intl/IntlContext';

import { CashProps } from './interface';
import styles from './payModal.module.scss';

const Cash: React.FC<CashProps> = (props) => {
  const { payAmount, payModalVisible } = props;

  const inputRef = useRef(null);
  const [cashForm] = Form.useForm(null);

  const [cash, setCash] = useState(0);
  const [restCash, setRestCash] = useState(0);
  const intlCtx = useContext(IntlContext);

  // 输入现金
  const changeCash = async () => {
    try {
      const values = await cashForm.validateFields();
      const tmpCash = +values.cash;

      setCash(tmpCash);
      setRestCash(parse2Number(parseYuan2Fen(tmpCash)) - payAmount);

      // callback parent
      props.inputCashCallback({
        isValid: true,
        cash: tmpCash,
      });
    } catch (err) {
      props.inputCashCallback({
        isValid: false,
        cash: err.values.cash,
      });
      setRestCash(0);
    }
  };

  // 回车键快捷提交
  const enterSubmit = async () => {
    try {
      await cashForm.validateFields();
      props.submitCashPay();
    } catch (err) {
      message.warning(renderIntlLabel('bill_msg_please_check_input'));
    }
  };

  // 初始化
  useEffect(() => {
    if (payModalVisible) {
      inputRef.current!.focus();
    }
  }, [payModalVisible]);

  // reset states when unmounted
  useEffect(() => {
    return () => {
      setCash(0);
      setRestCash(0);
    };
  }, []);

  return (
    <div className={styles['pay-content']}>
      <Form form={cashForm} preserve={false} className={styles['cash-form']}>
        <Form.Item
          label={renderIntlLabel('bill_label_guest_pay')}
          name="cash"
          rules={[
            {
              validator: (_, value) => {
                return validateAmount(value, {
                  required: true,
                });
              },
            },
          ]}
        >
          <Input
            ref={inputRef}
            prefix={intlCtx.TenantBaseConfig.CurrencySymbol}
            placeholder={renderIntlLabel('bill_msg_please_input_money')}
            value={cash}
            onPressEnter={() => enterSubmit()}
            onChange={() => changeCash()}
            onBlur={(e) => {
              const v = formatAmount(e.target.value);
              cashForm.setFieldsValue({
                cash: v,
              });
            }}
          />
        </Form.Item>
      </Form>
      <div className={styles['loose-change']}>
        <label className="text-colon">{renderIntlLabel('bill_label_give_change')}</label>
        {restCash > 0 ? <span>{parseFen2Currency(restCash)}</span> : '-'}
      </div>
    </div>
  );
};

export default Cash;
